import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Mail, X } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const EmailVerificationBanner = () => {
  const { user, token } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Don't show if: no user, already verified, dismissed, or Google auth user
  if (!user || user.email_verified || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/api/auth/send-verification`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Código de verificación enviado a tu correo');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al enviar verificación');
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      className="fixed top-14 md:top-11 left-0 right-0 z-[35] bg-amber-50 border-b border-amber-200"
      data-testid="email-verification-banner"
    >
      <div className="max-w-5xl mx-auto px-4 py-2.5 flex items-center gap-3">
        <Mail className="w-4 h-4 text-amber-600 flex-shrink-0" />
        <p className="text-xs sm:text-sm text-amber-700 flex-1">
          Verifica tu correo <span className="font-medium">{user.email}</span> para acceder a todas las funciones.
        </p>
        <button
          onClick={handleResend}
          disabled={sending}
          className="text-xs font-medium text-amber-700 bg-amber-100 hover:bg-amber-200 px-3 py-1 rounded-full transition-colors whitespace-nowrap disabled:opacity-50"
          data-testid="resend-verification-btn"
        >
          {sending ? 'Enviando...' : 'Reenviar'}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 rounded-full hover:bg-amber-100 transition-colors flex-shrink-0"
          data-testid="dismiss-verification-banner"
        >
          <X className="w-3.5 h-3.5 text-amber-500" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
